import { ContentMap } from '../types';
import { cambodiaDestinationsContentMap } from './cambodia/cambodia-destinations-card-map';
import { thailandDestinationsContentMap } from './thailand/thailand-destinations-card-map';
import { vietnamDestinationsContentMap } from './vietnam/vietnam-destinations-card-map';

export const destinationsContent: ContentMap = {
  ...thailandDestinationsContentMap,
  ...cambodiaDestinationsContentMap,
  ...vietnamDestinationsContentMap,
};
